export default {
  zh: {
    lead: '潜在客户搜索结果',
    account: '客户搜索结果',
    displayRule: '搜索条件过于宽泛，请重新调整你的搜索条件再进行搜索',
    selectionRule: '最多可以选择4个潜在客户进行合并',
  },
  en: {
    lead: 'Results Leads',
    account: 'Results Accounts',
    displayRule: 'More than 20 records are found. Please refine the above filters and search again.',
    selectionRule: 'Maximum 4 leads can be selected at the same time.',
  },
};



// WEBPACK FOOTER //
// ./src/components/ui/FilterResultsTable/i18n.js